import { render, staticRenderFns } from "./NotificationIndicator.vue?vue&type=template&id=d840b548"
import script from "./NotificationIndicator.vue?vue&type=script&lang=js"
export * from "./NotificationIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports